export default __webpack_public_path__ + "static/media/play-circle-filled-lime.a494c26b.svg";